function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import classNames from 'classnames';
var prefixCls = 'eui-popover';
/*
  组件的state是否完全由组件自己控制
  是则不关心props变化
  否则关心props变化, 根据props变化重新设置自己的state, 进而改变视图

  如果传入的visible为undefined
  则由组件自己控制显示隐藏，
  否则通过onShow和onHide来告诉使用者来控制显示和隐藏
*/

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  // showPopper是否由组件自己handle
  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPopper: false,
      createdContainer: false
    });

    _defineProperty(_assertThisInitialized(_this), "hasBindPopperEvent", false);

    _defineProperty(_assertThisInitialized(_this), "selfHandle", false);

    _defineProperty(_assertThisInitialized(_this), "bindEvent", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          triggerDiv = _assertThisInitialize.triggerDiv;

      var trigger = _this.props.trigger;

      if (trigger !== 'hover') {
        triggerDiv.addEventListener('click', _this.handleClick);
        document.addEventListener('click', _this.handleDocumentClick);
      } else {
        triggerDiv.addEventListener('mouseenter', _this.handleMouseEnter);
        triggerDiv.addEventListener('mouseleave', _this.handleMouseLeave);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createPopperContainer", function () {
      var div = document.createElement('div');
      document.body.appendChild(div);
      div.style.cssText = 'position: absolute; top: 0px; left: 0px; width: 100%;';
      _this.popperContainer = div;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (e) {
      var trigger = _this.props.trigger;

      if (_this.triggerDiv && _this.triggerDiv.contains(e.target)) {
        return;
      }

      if (trigger === 'focus' && _this.popper && _this.popper.contains(e.target)) {
        _this.setShowPopper(false);
      }

      if (_this.popper && _this.popper.contains(e.target)) {
        return;
      }

      _this.setShowPopper(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var showPopper = _this.state.showPopper;

      _this.setShowPopper(!showPopper);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.setShowPopper(true);

      window.clearTimeout(_this.mouseLeaveTimer);
      _this.mouseLeaveTimer = null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.mouseLeaveTimer = setTimeout(function () {
        _this.setShowPopper(false);
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "setShowPopper", function (showPopper) {
      var _this$props = _this.props,
          onShow = _this$props.onShow,
          onHide = _this$props.onHide;
      var preShowPopper = _this.state.showPopper;
      if (preShowPopper === showPopper) return;

      if (_this.selfHandle) {
        _this.setState({
          showPopper: showPopper
        });
      }

      if (showPopper && onShow) onShow();
      if (!showPopper && onHide) onHide();
    });

    _defineProperty(_assertThisInitialized(_this), "getPopperStyle", function () {
      var _this$props2 = _this.props,
          position = _this$props2.position,
          distance = _this$props2.distance;

      if (!(_this.triggerDiv && _this.triggerDiv.children && _this.triggerDiv.children[0])) {
        return {};
      }

      var child = _this.triggerDiv.children[0];

      var _child$getBoundingCli = child.getBoundingClientRect(),
          top = _child$getBoundingCli.top,
          left = _child$getBoundingCli.left,
          right = _child$getBoundingCli.right,
          bottom = _child$getBoundingCli.bottom,
          width = _child$getBoundingCli.width,
          height = _child$getBoundingCli.height;

      var _document$documentEle = document.documentElement,
          scrollTop = _document$documentEle.scrollTop,
          scrollLeft = _document$documentEle.scrollLeft;
      var style = {
        top: 0,
        left: 0,
        zIndex: 10000
      };
      var isFixed = _this.popper && getComputedStyle(_this.popper).position === 'fixed';
      var comTop = isFixed ? top : top + scrollTop;
      var comBottom = isFixed ? bottom : bottom + scrollTop;
      var comLeft = isFixed ? left : left + scrollLeft;
      var comRight = isFixed ? right : right + scrollLeft;

      if (position === 'top') {
        style.top = comTop - distance;
        style.left = comLeft + width / 2;
      } else if (position === 'right') {
        style.top = comTop + height / 2;
        style.left = comRight + distance;
      } else if (position === 'bottom') {
        style.top = comBottom + distance;
        style.left = comLeft + width / 2;
      } else {
        // default = left
        style.top = comTop + height / 2;
        style.left = comLeft - distance;
      }

      return style;
    });

    _defineProperty(_assertThisInitialized(_this), "getNestPopperStyle", function () {
      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "renderPopper", function () {
      var _this$props3 = _this.props,
          content = _this$props3.content,
          popperClassName = _this$props3.popperClassName,
          position = _this$props3.position,
          noArrow = _this$props3.noArrow;
      var _this$state = _this.state,
          showPopper = _this$state.showPopper,
          createdContainer = _this$state.createdContainer;
      var className = classNames( // prefixCls,
      popperClassName, "".concat(prefixCls, "-content"), "".concat(prefixCls, "-content--").concat(position), "".concat(!noArrow ? "".concat(prefixCls, "-content-arrow") : ''), "".concat(showPopper ? "".concat(prefixCls, "-content--active") : ''));
      return createdContainer ? createPortal(React.cloneElement( /*#__PURE__*/React.createElement("div", null, content), {
        ref: function ref(el) {
          _this.popper = el;
        },
        className: className,
        style: _this.getPopperStyle()
      }), _this.popperContainer) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderNestPopper", function () {
      var _this$props4 = _this.props,
          content = _this$props4.content,
          popperClassName = _this$props4.popperClassName,
          position = _this$props4.position,
          noArrow = _this$props4.noArrow;
      var showPopper = _this.state.showPopper;
      var className = classNames(popperClassName, "".concat(prefixCls, "-content"), "".concat(prefixCls, "-content--").concat(position), "".concat(!noArrow ? "".concat(prefixCls, "-content-arrow") : ''), "".concat(showPopper ? "".concat(prefixCls, "-content--active") : ''));
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this.popper = el;
        },
        className: className,
        style: _this.getNestPopperStyle()
      }, content);
    });

    _this.selfHandle = props.visible === undefined;
    _this.state.showPopper = _this.selfHandle ? false : props.visible;
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPopperContainer();
      this.bindEvent();
      this.setState({
        createdContainer: true
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nProps) {
      var nVisible = nProps.visible;
      var visible = this.props.visible;
      if (this.selfHandle) return;

      if (visible != nVisible) {
        this.setState({
          showPopper: nVisible
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var trigger = this.props.trigger;

      if (trigger === 'hover' && this.popper && !this.hasBindPopperEvent) {
        this.hasBindPopperEvent = true;
        this.popper.addEventListener('mouseenter', this.handleMouseEnter);
        this.popper.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // 删除节点
      // ReactDOM.unmountComponentAtNode(this.popperContainer);
      document.body.removeChild(this.popperContainer); // 事件解绑

      this.triggerDiv.removeEventListener('mouseenter', this.handleMouseEnter);
      this.triggerDiv.removeEventListener('mouseleave', this.handleMouseLeave);
      this.triggerDiv.removeEventListener('click', this.handleClick);
      document.removeEventListener('click', this.handleDocumentClick);

      if (this.popper) {
        this.popper.removeEventListener('mouseenter', this.handleMouseEnter);
        this.popper.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this2.triggerDiv = el;
        }
      }, children, this.renderPopper());
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "propTypes", {
  popperClassName: PropTypes.string,
  children: PropTypes.node,
  trigger: PropTypes.oneOf(['click', 'hover', 'focus']),
  content: PropTypes.any.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  visible: PropTypes.bool,
  noArrow: PropTypes.bool,
  distance: PropTypes.number // nest: PropTypes

});

_defineProperty(Popover, "defaultProps", {
  popperClassName: '',
  children: [],
  trigger: 'click',
  position: 'top',
  onShow: undefined,
  onHide: undefined,
  visible: undefined,
  noArrow: false,
  distance: 10 // nest: false

});

export default Popover;